const funnelEndpoint = () => {
  if (typeof window === 'undefined') return '/api/funnel/event';
  const hostname = String(window.location?.hostname || '').toLowerCase();
  return hostname === 'phantompathvpn.com' || hostname === 'www.phantompathvpn.com'
    ? 'https://api.phantompathvpn.com/api/funnel/event'
    : '/api/funnel/event';
};
export const AGGREGATE_STATISTICS_PREFERENCE_KEY = 'phantompath_aggregate_statistics_v1';

const normaliseProductSku = (value) => String(value || '')
  .trim().toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '').slice(0, 120);

export const getAggregateStatisticsPreference = () => {
  if (typeof window === 'undefined') return 'on';
  try { return window.localStorage.getItem(AGGREGATE_STATISTICS_PREFERENCE_KEY) === 'off' ? 'off' : 'on'; }
  catch (_error) { return 'on'; }
};

export const setAggregateStatisticsPreference = (preference) => {
  if (typeof window === 'undefined') return;
  try { window.localStorage.setItem(AGGREGATE_STATISTICS_PREFERENCE_KEY, preference === 'off' ? 'off' : 'on'); }
  catch (_error) {}
};

export const statisticalMeasurementObjected = () => {
  if (typeof window === 'undefined') return true;
  const queryPreference = new URLSearchParams(window.location.search).get('aggregate_statistics');
  return getAggregateStatisticsPreference() === 'off'
    || queryPreference === 'off'
    || navigator.globalPrivacyControl === true
    || navigator.doNotTrack === '1'
    || window.doNotTrack === '1';
};

export const funnelProductFromElement = (element) => {
  const productElement = element?.dataset?.productId ? element : element?.closest?.('[data-product-id]');
  const productSku = normaliseProductSku(productElement?.dataset?.productId);
  return productSku ? { productSku } : null;
};

export const recordFirstPartyFunnel = (eventType, product) => {
  if (statisticalMeasurementObjected() || !product?.productSku) return;
  void fetch(funnelEndpoint(), {
    method: 'POST', credentials: 'omit', cache: 'no-store', keepalive: true,
    referrerPolicy: 'no-referrer', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ eventType, productSku: product.productSku }),
  }).catch(() => {});
};
